import { createIcon } from '@chakra-ui/icon'

const CSSIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <g transform="translate(5311 -4734.065)">
      <path
        fill="#FFFFFF"
        d="M-5242.5,4817.5h-59c-2.5,0-4.5-2-4.5-4.5v-71c0-2.5,2-4.5,4.5-4.5h44.4l19.1,17.3v58.2  C-5238,4815.5-5240.1,4817.5-5242.5,4817.5z"
      />
      <path
        fill="#E1E4EA"
        d="M-5242.5,4817c2.2,0,4-1.8,4-4v-58l-18.8-17h-44.2c-2.2,0-4,1.8-4,4v71c0,2.2,1.8,4,4,4H-5242.5 M-5242.5,4818 h-59c-2.8,0-5-2.2-5-5v-71c0-2.8,2.2-5,5-5h44.6l19.4,17.6v58.4C-5237.5,4815.8-5239.8,4818-5242.5,4818z"
      />
      <path
        fill="#6068B7"
        d="M-5237.5,4767h-69v-25c0-2.8,2.2-5,5-5h45.6l18.4,17.5V4767z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.6"
        enableBackground="new"
        d="M-5255.8,4737.1v9.9c0,0-0.4,7.4,7.8,7.5s10.4,0,10.4,0L-5255.8,4737.1z"
      />
      <text
        transform="matrix(1 0 0 1 -5299.5332 4756.0322)"
        fill="#F7FAFC"
        fontFamily="ArialMT"
        fontSize="12px"
      >
        CSS
      </text>
      <g transform="translate(15.474)">
        <path
          fill="#E1E4EB"
          d="M-5291.8,4805.4c-0.1,0-0.2,0-0.3,0c-0.4-0.2-0.7-0.7-0.5-1.1c0,0,0,0,0,0l8.6-24.1 c0.2-0.4,0.7-0.7,1.1-0.5c0.4,0.2,0.7,0.7,0.5,1.1l-8.6,24.1C-5291.1,4805.2-5291.4,4805.4-5291.8,4805.4z"
        />
      </g>
      <g transform="translate(0 6.878)">
        <path
          fill="#E1E4EB"
          d="M-5279.8,4791.7c-0.1,0-0.2,0-0.3-0.1l-12-5.2c-0.4-0.2-0.6-0.7-0.5-1.1 c0.1-0.2,0.2-0.4,0.5-0.5l12-5.2c0.4-0.2,0.9,0,1.1,0.5c0.2,0.4,0,0.9-0.5,1.1l-10.2,4.4l10.2,4.4c0.4,0.2,0.6,0.7,0.5,1.1 C-5279.1,4791.5-5279.4,4791.7-5279.8,4791.7L-5279.8,4791.7z"
        />
      </g>
      <g transform="translate(27.511 6.879)">
        <path
          fill="#E1E4EB"
          d="M-5291.8,4791.7c-0.5,0-0.9-0.4-0.9-0.9c0-0.3,0.2-0.7,0.5-0.8l10.2-4.4l-10.2-4.4 c-0.4-0.2-0.6-0.7-0.5-1.1c0.2-0.4,0.7-0.6,1.1-0.5l12,5.2c0.4,0.2,0.6,0.7,0.5,1.1c-0.1,0.2-0.2,0.4-0.5,0.5l-12,5.2 C-5291.6,4791.6-5291.7,4791.7-5291.8,4791.7z"
        />
      </g>
    </g>
  ),
})

export default CSSIcon
